<section class="package-drawer" aria-label="Package List">
  <header class="package-drawer__header">
    <h2>Package List</h2>
    <div class="package-drawer__header-actions">
      <enr-button-group
        size="medium"
        ariaLabel="Package list view"
        variant="round"
        data-testid="pricing-package-drawer-view"
        [options]="viewOptions"
        [value]="view()"
        (valueChange)="setView($event)"
      />
      <enr-search
        class="package-drawer__search"
        size="medium"
        placeholder="Search packages"
        ariaLabel="Search packages"
        [value]="searchTerm()"
        [loading]="loading()"
        [clearable]="true"
        (search)="onSearch($event)"
        (clear)="clearSearch()"
      />
    </div>
  </header>

  <div class="package-drawer__divider" aria-hidden="true"></div>

  @if (loadError()) {
  <div class="package-drawer__message" role="alert">{{ loadError() }}</div>
  } @else if (loading()) { @if (view() === "Grid") {
  <div
    class="package-drawer__grid package-drawer__grid--loading"
    aria-busy="true"
    aria-label="Loading package cards"
  >
    @for (card of [1, 2, 3, 4, 5, 6]; track card) {
    <div class="package-card-skeleton" aria-hidden="true">
      <span
        class="package-card-skeleton__bar package-card-skeleton__bar--name"
      ></span>
      <span
        class="package-card-skeleton__bar package-card-skeleton__bar--price"
      ></span>
      <span
        class="package-card-skeleton__bar package-card-skeleton__bar--detail"
      ></span>
      <span class="package-card-skeleton__divider"></span>
      <span
        class="package-card-skeleton__bar package-card-skeleton__bar--meta"
      ></span>
    </div>
    }
  </div>
  } @else {
  <div
    class="package-drawer__list package-drawer__list--loading"
    aria-busy="true"
    aria-label="Loading package list"
  >
    <div class="package-list-row package-list-row--header" aria-hidden="true">
      <span>Offering price ID</span>
      <span>Package name</span>
      <span>Type</span>
      <span>Status</span>
      <span class="package-list-row__price-head">Price</span>
    </div>
    @for (row of [1, 2, 3, 4, 5, 6, 7, 8]; track row) {
    <div class="package-list-skeleton" aria-hidden="true">
      <span
        class="package-list-skeleton__bar package-list-skeleton__bar--id"
      ></span>
      <span
        class="package-list-skeleton__bar package-list-skeleton__bar--name"
      ></span>
      <span
        class="package-list-skeleton__bar package-list-skeleton__bar--type"
      ></span>
      <span
        class="package-list-skeleton__bar package-list-skeleton__bar--status"
      ></span>
      <span
        class="package-list-skeleton__bar package-list-skeleton__bar--price"
      ></span>
    </div>
    }
  </div>
  } } @else if (packages().length === 0) {
  <div class="package-drawer__message">No packages found.</div>
  } @else if (view() === "Grid") {
  <div class="package-drawer__grid" role="list" aria-label="Package cards">
    @for (item of packages(); track trackPackage($index, item)) {
    <button
      type="button"
      class="package-card"
      [class.package-card--selected]="isSelected(item.id)"
      [attr.aria-pressed]="isSelected(item.id)"
      [disabled]="!isSelectable(item)"
      [attr.title]="isSelectable(item) ? null : 'Only launched packages can be selected'"
      (click)="selectPackage(item)"
    >
      <span class="package-card__top">
        <span class="package-card__name" [title]="item.name || item.id"
          >{{ item.name || item.id }}</span
        >
        <span class="package-card__price">{{ priceLabel(item) }}</span>
      </span>
      <span class="package-card__details">
        <span>{{ priceTypeLabel(item) }}</span>
        @if (statusChip(item); as status) {
        <enr-status
          size="small"
          [status]="status.type"
          [customText]="status.label"
        />
        } @if (validForLabel(item); as validFor) {
        <span>{{ validFor }}</span>
        }
      </span>
      <span class="package-card__divider" aria-hidden="true"></span>
      <span class="package-card__bottom">
        <mat-icon aria-hidden="true">sell</mat-icon>
        <span
          >{{ packageMeta(item) || item.descriptionShort || "Package price"
          }}</span
        >
      </span>
      <span class="package-card__radio" aria-hidden="true"></span>
    </button>
    }
  </div>
  } @else {
  <div class="package-drawer__list" role="list" aria-label="Package list">
    <div class="package-list-row package-list-row--header" aria-hidden="true">
      <span>Offering price ID</span>
      <span>Package name</span>
      <span>Type</span>
      <span>Status</span>
      <span class="package-list-row__price-head">Price</span>
    </div>
    @for (item of packages(); track trackPackage($index, item)) {
    <button
      type="button"
      class="package-list-row"
      [class.package-list-row--selected]="isSelected(item.id)"
      [attr.aria-pressed]="isSelected(item.id)"
      [disabled]="!isSelectable(item)"
      [attr.title]="isSelectable(item) ? null : 'Only launched packages can be selected'"
      (click)="selectPackage(item)"
    >
      <span class="package-list-row__id">{{ item.id }}</span>
      <span class="package-list-row__name">
        <strong>{{ item.name || item.id }}</strong>
        @if (packageMeta(item)) {
        <small>{{ packageMeta(item) }}</small>
        }
      </span>
      <span>{{ priceTypeLabel(item) }}</span>
      <span class="package-list-row__status">
        @if (statusChip(item); as status) {
        <enr-status
          size="small"
          [status]="status.type"
          [customText]="status.label"
        />
        } @else { - }
      </span>
      <span class="package-list-row__price">{{ priceLabel(item) }}</span>
      <span class="package-list-row__radio" aria-hidden="true"></span>
    </button>
    }
  </div>
  }

  <footer class="package-drawer__footer">
    <enr-pagination
      [config]="paginationConfig()"
      [loading]="loading()"
      (pageChange)="goToPage($event)"
      (pageSizeChange)="setPageSize($event)"
    />
    <div class="package-drawer__actions">
      <enr-button variant="outline" type="button" (clicked)="close()"
        >Cancel</enr-button
      >
      <enr-button
        variant="primary"
        type="button"
        [disabled]="!selectedPackage()"
        (clicked)="saveSelection()"
        >Save</enr-button
      >
    </div>
  </footer>
</section>
